import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=18c571e8&scoped=true&"
var script = {}
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=18c571e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c571e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c571e8')) {
      api.createRecord('18c571e8', component.options)
    } else {
      api.reload('18c571e8', component.options)
    }
    module.hot.accept("./CardSkeleton.vue?vue&type=template&id=18c571e8&scoped=true&", function () {
      api.rerender('18c571e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/Skeletons/CardSkeleton.vue"
export default component.exports